import React from "react";
import Backdrop from "../../Backdrop/Backdrop";
import NavList from "../NavList/NavList";
import classes from "./SideDrawer.module.css";

type SideDrawerProps = { show: boolean; backdropClickHandler: () => void };

const SideDrawer: React.FC<SideDrawerProps> = (props) => {
    let isOpenClass = props.show ? classes.Open : classes.Close;

    return (
        <div>
            <Backdrop show={props.show} click={props.backdropClickHandler} />
            <div className={[classes.SideDrawer, isOpenClass /* classes.HideInDesktop */].join(" ")}>
                <nav>
                    <NavList />
                </nav>
            </div>
        </div>
    );
};

export default SideDrawer;
